import SmoothScroll from 'smooth-scroll';

export default class Smoothscroll {
  constructor() {
    this.setup();
  }
  setup() {
    SmoothScroll('a[href*="#"]', {
      ignore: '[data-scroll-ignore]',
      header: '.header_fs',
      topOnEmptyHash: true,
      speed: 600,
      speedAsDuration: true,
      easing: 'easeInOutCubic',
      updateURL: false
    });
  }
}
